import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import visualization from './visualization_w.png';
import interactive from './interactive.png';
import './App.css';
import Signup from './Signup';
import Demo from './Demo';

/* Placeholder – replace `me_logo_placeholder.png` with the real file when ready */
import logo from './mindengage-logo-333.png';

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white font-sans">
      <header className="bg-gradient-to-b from-indigo-900 to-gray-900 py-16 text-center sticky top-0 z-50">
        {/* Logo placeholder */}
        <img
          src={logo}
          alt="MindEngage Logo"
          className="w-12 h-12 absolute top-4 left-4"
        />

        <div className="text-white font-semibold mb-2">MindEngage</div>
        <h1 className="text-4xl font-bold">Transforming STEM learning experiences</h1>
        <p className="mt-3 text-xl">Boost student engagement with interactive content</p>
      </header>

      <section className="bg-white py-20 text-gray-800 px-4 md:px-20">
        <div className="max-w-screen-lg mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-2xl font-bold mb-8">Key Benefits</h2>
              <ul className="space-y-4">
                <li>
                  <span className="font-semibold">Enhanced Engagement:</span> Interactive experiences boost student interest.
                </li>
                <li>
                  <span className="font-semibold">Personalized Learning:</span> Effortlessly create tailored courses for each student.
                </li>
                <li>
                  <span className="font-semibold">Dynamic Visualizations:</span> Transform static content into interactive visualizations.
                </li>
                <li>
                  <span className="font-semibold">Easy Course Creation:</span> Quickly generate personalized courses for students.
                </li>
              </ul>
            </div>
            <div>
              <img src={visualization} alt="Visualization" className="rounded-xl" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-800 py-16 px-4 md:px-20 text-center">
        <div className="grid md:grid-cols-3 gap-8 text-gray-300 italic">
          <p>
            "MindEngage revolutionizes teaching approach."<br />
            <span className="text-sm"></span>
          </p>
          <p>
            "Students are more engaged and perform better."<br />
            <span className="text-sm"></span>
          </p>
          <p>
            "Creating interactive courses is now a breeze."<br />
            <span className="text-sm"></span>
          </p>
        </div>
      </section>

      <section className="bg-white py-20 px-4 md:px-20 text-gray-800">
        <div className="max-w-screen-lg mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <img src={interactive} alt="Interactive Content" className="rounded-xl shadow-lg" />
            <div>
              <h2 className="text-2xl font-bold mb-8">Features</h2>
              <ul className="space-y-4">
                <li>
                  <span className="font-semibold">Interactive Content:</span> Convert static learning materials to engaging activities.
                </li>
                <li>
                  <span className="font-semibold">Personalized Courses:</span> Tailor educational content to individual student needs.
                </li>
                <li>
                  <span className="font-semibold">Data Visualizations:</span> Present complex concepts through interactive graphics.
                </li>
                <li>
                  <span className="font-semibold">Effortless Creation:</span> Easily generate customized courses with a few clicks.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 py-10 text-center">
        <h3 className="text-2xl font-bold">Unlock Interactive Learning Today</h3>
        <p className="mt-2">Transform your educational content with MindEngage.</p>
        <Link to="/signup">
          <button className="mt-4 bg-indigo-500 text-white py-2 px-6 rounded-lg">
          Join the Beta Program
          </button>
        </Link>
        <Link to="/demo">
          <button className="mt-4 ml-4 bg-green-500 text-white py-2 px-6 rounded-lg">
          View Demo Courses
          </button>
        </Link>
        <div className="mt-6">
          <a
            href="https://author.mindengage.net/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white underline"
          >
            Privacy Policy
          </a>
        </div>
      </footer>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/demo" element={<Demo />} />
      </Routes>
    </Router>
  );
};

export default App;

